var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 15,
    viewBox: "0 0 4 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33854 2.16667C1.33854 2.53486 1.63702 2.83333 2.00521 2.83333C2.3734 2.83333 2.67188 2.53486 2.67188 2.16667C2.67188 1.79848 2.3734 1.5 2.00521 1.5C1.63702 1.5 1.33854 1.79848 1.33854 2.16667Z",
    stroke: "#151515",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33854 7.50065C1.33854 7.86884 1.63702 8.16732 2.00521 8.16732C2.3734 8.16732 2.67188 7.86884 2.67188 7.50065C2.67188 7.13246 2.3734 6.83398 2.00521 6.83398C1.63702 6.83398 1.33854 7.13246 1.33854 7.50065Z",
    stroke: "#151515",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33854 12.8327C1.33854 13.2009 1.63702 13.4993 2.00521 13.4993C2.3734 13.4993 2.67188 13.2009 2.67188 12.8327C2.67188 12.4645 2.3734 12.166 2.00521 12.166C1.63702 12.166 1.33854 12.4645 1.33854 12.8327Z",
    stroke: "#151515",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotMenu);
export default __webpack_public_path__ + "static/media/dot-menu.ba4e1f40519ddcb86fe06344f56d15a1.svg";
export { ForwardRef as ReactComponent };